import { QUERY_KEYS } from "@/libraries/constant";
import { askHemiService } from "@/services/askhemi";
import type { QueryClient } from "@tanstack/react-query";

export const askHemiMutations = (queryClient: QueryClient) => {
	queryClient.setMutationDefaults([QUERY_KEYS.MUTATE_START_CARE_CHAT], {
		mutationFn: (payload: { caseId: number }) =>
			askHemiService.startCareChat(payload.caseId),
		onSuccess: (_res, payload) => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.GET_CARE_CHAT, String(payload.caseId)],
			});
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.GET_CARE_CHAT_MESSAGES, String(payload.caseId)],
			});
		},
	});
	queryClient.setMutationDefaults([QUERY_KEYS.MUTATE_CLOSE_CARE_CHAT], {
		mutationFn: (payload: { caseId: number }) =>
			askHemiService.closeCareChat(payload.caseId),
		onSuccess: (_res, payload) => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.GET_CARE_CHAT, String(payload.caseId)],
			});
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.GET_CARE_CHAT_MESSAGES, String(payload.caseId)],
			});
		},
	});
	queryClient.setMutationDefaults([QUERY_KEYS.MUTATE_SEND_CARE_CHAT_MESSAGE], {
		mutationFn: (payload: { caseId: number; text: string }) =>
			askHemiService.sendCareChatMessage(payload.caseId, payload.text),
		onSuccess: (_res, payload) => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.GET_CARE_CHAT_MESSAGES, String(payload.caseId)],
			});
		},
	});
	queryClient.setMutationDefaults([QUERY_KEYS.MUTATE_CREATE_WOUND_ANALYSIS], {
		mutationFn: (payload: { caseId: number; shareId: number }) =>
			askHemiService.createWoundAnalysis(payload.caseId, payload.shareId),
		onSuccess: (res, payload) => {
			queryClient.setQueryData(
				[QUERY_KEYS.GET_WOUND_ANALYSIS, String(res.id)],
				res,
			);
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.GET_WOUND_ANALYSES, String(payload.caseId)],
			});
		},
	});
};
